module.exports = __webpack_public_path__ + "img/cimb.38120fcc.svg";